import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import InputField from 'components/formComponents/inputField';
import SelectField from 'components/formComponents/selectField';
import BullionConfigApi from 'api/bullionconfig';
import { BullionConfigValidationSchema } from 'formValidations/bullionConfigFormValidations';
import { MetalTypesOptions } from 'config/constant';

export default function PopModal(props) {
  const initialData = props.initialData;
  console.log('initialdata = ', initialData);
  const id = props.id;
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log('From Api Call', values);
    try {
      const response = await BullionConfigApi.Update({
        id,
        ...values,
      });
      if (response.data.status_code === 200) {
        toast({
          title: response?.data?.message || 'Successfully Updated',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        props.func();
      } else if (response.data.statusCode !== 200) {
        console.log('Error in Response', response);
        toast({
          title: response?.data?.message || 'Error in Updating',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
      toast({
        title: err?.response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button
        onClick={onOpen}
        disabled={props.disabled}>
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Formik
              initialValues={initialData}
              validationSchema={BullionConfigValidationSchema}
              onSubmit={handleSubmit}>
              {({ isSubmitting }) => (
                <Form noValidate>
                  <Flex
                    justifyContent='space-between'
                    gap={5}>
                    <SelectField
                      label='type'
                      name='type'
                      options={MetalTypesOptions}
                      required
                    />
                    <InputField
                      label='Unit'
                      name='unit'
                      type='text'
                      variant='auth'
                      defaultValue='gm'
                      disabled
                    />
                  </Flex>
                  <InputField
                    label='Sell Price Percentage Deviation'
                    name='sell_price_percentage_deviation'
                    type='number'
                    required
                  />
                  <InputField
                    label='Buy Price Percentage Deviation'
                    name='buy_price_percentage_deviation'
                    type='number'
                    required
                  />
                  <InputField
                    label='Exchange Price Percentage Deviation'
                    name='exchange_price_percentage_deviation'
                    type='number'
                    required
                  />
                  <InputField
                    label='Max Buy Limit'
                    name='customer_max_buy'
                    type='number'
                    variant='auth'
                    disabled
                  />
                  <InputField
                    label='Max Sell Limit'
                    name='customer_max_sell'
                    type='number'
                    variant='auth'
                    disabled
                  />
                  <InputField
                    label='Sell Threshold'
                    name='threshold_sell'
                    type='number'
                    required
                  />
                  <InputField
                    label='Buy Threshold'
                    name='threshold_buy'
                    type='number'
                    required
                  />
                  <ModalFooter>
                    <Button
                      colorScheme='blue'
                      mr={3}
                      type='submit'
                      isLoading={isSubmitting}>
                      Update
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
